module.exports = __webpack_public_path__ + "static/media/sentVideo.1aeb5fe0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/sentVideo.mp4
// module id = 664
// module chunks = 0